import { NgModule } from '@angular/core';
import { ApiHttpClientService } from './api-http-client.service';

@NgModule({
  providers: [ApiHttpClientService]
})
export class ApiHttpClientModule { }
